import { colors } from "helpers/colors";
import React from "react";
import { createUseStyles } from "react-jss";
import Offer6 from "./Offer6";

interface IProps {
  offers: any[];
}

export default function Template6(props: IProps) {
  const { offers } = props;
  const classes = useStyles();

  return (
    <div className={classes.container}>
      {offers.map((offer) => (
        <div
          key={`template6-${offer.id}-${Math.random()}`}
          style={{
            width: 1920 / 3,
            height: 1080 / 2,
            display: "flex",
            position: "relative",
          }}
          className={"offer-container"}
        >
          <Offer6 offer={offer} />
        </div>
      ))}
    </div>
  );
}

const useStyles = createUseStyles({
  container: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "space-between",
    height: "100%",
    width: "100%",
    "& .offer-container": {
      boxSizing: "border-box",
      "&:nth-child(1)": {
        borderRight: `4px solid ${colors.imko}`,
        borderBottom: `3px solid ${colors.imko}`,
      },
      "&:nth-child(2)": {
        borderLeft: `2px solid ${colors.imko}`,
        borderRight: `2px solid ${colors.imko}`,
        borderBottom: `3px solid ${colors.imko}`,
      },
      "&:nth-child(3)": {
        borderLeft: `4px solid ${colors.imko}`,
        borderBottom: `3px solid ${colors.imko}`,
      },
      "&:nth-child(4)": {
        borderRight: `4px solid ${colors.imko}`,
        borderTop: `3px solid ${colors.imko}`,
      },
      "&:nth-child(5)": {
        borderRight: `2px solid ${colors.imko}`,
        borderLeft: `2px solid ${colors.imko}`,
        borderTop: `3px solid ${colors.imko}`,
      },
      "&:nth-child(6)": {
        borderTop: `3px solid ${colors.imko}`,
        borderLeft: `4px solid ${colors.imko}`,
      },
    },
  },
});
